<template>
    <!-- @todo [CLENG-4936] remove hidden input once FormData-based CreateAccount, EditAccount forms are migrated to reactive submission -->
    <input
        :id
        ref="hiddenInputRef"
        :data-diff-modal-label="label ?? 'State'"
        :name
        type="hidden"
        :value="selectedState"
        @change="selectedState = ($event.target as HTMLInputElement).value || undefined"
    />
    <DsSingleSelect
        v-model="selectedOption"
        :id="dsSingleSelectId"
        :disabled="isDisabled"
        :label="label ?? 'State'"
        :options="STATE_NAME_OPTIONS"
        placeholder="Select a state"
        :required
        searchInputPlaceholder="Search states"
    />
</template>

<script setup lang="ts">
import { STATE_NAME_OPTIONS, type StateNameOption } from '@/shared/utils/states';
import DsSingleSelect from '@ds/singleselect/DsSingleSelect.vue';
import { computed, nextTick, ref, useId, watch } from 'vue';

defineProps<{
    id?: string;
    label?: string;
    required?: boolean;
    name?: string;
    isDisabled?: boolean;
}>();

defineOptions({ inheritAttrs: false });

const dsSingleSelectId = useId();
const hiddenInputRef = ref<HTMLInputElement>();
const selectedState = defineModel<string>();

const selectedOption = computed<StateNameOption | undefined>({
    get: () => STATE_NAME_OPTIONS.find(opt => opt.id === selectedState.value),
    set: opt => {
        selectedState.value = opt?.value;
    },
});

/**
 * this is needed so the "Update account / branch" button gets enabled when the selected state changes
 * @todo [CLENG-4936] remove
 */
watch(selectedState, async () => {
    await nextTick();
    hiddenInputRef.value?.dispatchEvent(new Event('input', { bubbles: true }));
});
</script>
